module.exports = __webpack_public_path__ + "static/media/Stopwatch.4eec08a8.svg";